module.exports = __webpack_public_path__ + "7773ac255fbd01c79357cc2eded69ee5.svg";